import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './DobroFormText.css';

export interface IDobroFormTextProps {
  children: React.ReactNode;
}

export function DobroFormText(props: IDobroFormTextProps) {
  return (
    <div className={styles.text}>
      <UIText2 color="text-secondary-default">{props.children}</UIText2>
    </div>
  );
}
